import { UPDATE_UTILS } from './types';

export default (payload: unknown) => ({
  type: UPDATE_UTILS,
  payload,
});
